import { Container, Graphics } from 'pixi.js';

class AttackProgressBar extends Container {
  private graphic: Graphics;

  constructor(currentValue: number, maxValue: number) {
    super();

    this.graphic = new Graphics();
    this.graphic.beginFill(0xff6666);
    this.graphic.drawRoundedRect(-40, -3, 80 * (currentValue / maxValue), 4, 2);
    this.graphic.endFill();

    const backgroundGraphics = new Graphics();
    backgroundGraphics.lineStyle({ width: 2, color: 0x000000 });
    backgroundGraphics.beginFill(0x555555);
    backgroundGraphics.drawRoundedRect(-40, -3, 80, 4, 2);
    backgroundGraphics.endFill();

    this.addChild(backgroundGraphics);
    this.addChild(this.graphic);
  }

  public update(currentValue: number, maxValue: number): void {
    this.graphic.clear();
    this.graphic.beginFill(0xff6666);
    this.graphic.drawRoundedRect(-39, -2, 78 * (currentValue / maxValue), 2, 2);
    this.graphic.endFill();
  }
}

export default AttackProgressBar;
